import Raven from 'raven-js'

export function ravenInstall() {
  Raven.config('https://1c74aa1312d74eb8bcffbfd4e893703e@sentry.io/1231501', {
    environment: process.env.REACT_APP_ENV,
    release: process.env.REACT_APP_GIT_SHA1,
    ignoreUrls: [/http:\/\/localhost/],
  }).install()
}
